module.exports = __webpack_public_path__ + "static/media/info1.a57c1e78.png";